import { render, staticRenderFns } from "./centerPwd.vue?vue&type=template&id=03f82d43&scoped=true&"
import script from "./centerPwd.vue?vue&type=script&lang=js&"
export * from "./centerPwd.vue?vue&type=script&lang=js&"
import style0 from "./centerPwd.vue?vue&type=style&index=0&id=03f82d43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f82d43",
  null
  
)

export default component.exports